/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestDeliveryHoursChangeResponse
 */
export interface RequestDeliveryHoursChangeResponse {
    /**
     * Whether the carrier was emailed about the new hours. When false, the carrier only sees them on the updated bill of lading, so the customer must reprint the pickup package.
     * 
     * @type {boolean}
     * @memberof RequestDeliveryHoursChangeResponse
     */
    carrierEmailed: boolean;
}

/**
 * Check if a given object implements the RequestDeliveryHoursChangeResponse interface.
 */
export function instanceOfRequestDeliveryHoursChangeResponse(value: object): value is RequestDeliveryHoursChangeResponse {
    if (!('carrierEmailed' in value) || value['carrierEmailed'] === undefined) return false;
    return true;
}

export function RequestDeliveryHoursChangeResponseFromJSON(json: any): RequestDeliveryHoursChangeResponse {
    return RequestDeliveryHoursChangeResponseFromJSONTyped(json, false);
}

export function RequestDeliveryHoursChangeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestDeliveryHoursChangeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'carrierEmailed': json['carrierEmailed'],
    };
}

  export function RequestDeliveryHoursChangeResponseToJSON(json: any): RequestDeliveryHoursChangeResponse {
      return RequestDeliveryHoursChangeResponseToJSONTyped(json, false);
  }

  export function RequestDeliveryHoursChangeResponseToJSONTyped(value?: RequestDeliveryHoursChangeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'carrierEmailed': value['carrierEmailed'],
    };
}

